import {useTranslation} from '@/translations/i18n'
import {formatLocaleDate} from '@/dayjs'
import {StyledLastSyncedAt} from './style'

interface DashboardLastSyncedAtProps {
    lastSyncedAt?: string | null
}

export const DashboardLastSyncedAt = ({lastSyncedAt}: DashboardLastSyncedAtProps) => {
    const {t} = useTranslation()

    if (!lastSyncedAt) return null

    return (
        <StyledLastSyncedAt>
            {t('dashboard:last_synced_at', {dateTime: formatLocaleDate(lastSyncedAt, 'DD/MM/YY HH:mm')})}
        </StyledLastSyncedAt>
    )
}
